<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Material Design Icons</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://zavoloklom.github.io/material-design-iconic-font/index.html"
                      target="_black">Icons</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Getting Started</h5>
              <p>Material Design Iconic Font is a full suite of material design icons (created and maintained by <a
                  href="https://github.com/google/material-design-icons" target="_blank">Google</a>) with additional
                community-designed and brands icons for easy scalable vector graphics on websites or desktop.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="row">
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-3d-rotation zmdi-hc-fw"></i> <span>3d-rotation</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-airplane-off zmdi-hc-fw"></i> <span>airplane-off</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-airplane zmdi-hc-fw"></i> <span>airplane</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-album zmdi-hc-fw"></i>
                        <span>album</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-archive zmdi-hc-fw"></i>
                        <span>archive</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment-account zmdi-hc-fw"></i> <span>assignment-account</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment-alert zmdi-hc-fw"></i> <span>assignment-alert</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment-check zmdi-hc-fw"></i> <span>assignment-check</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment-o zmdi-hc-fw"></i> <span>assignment-o</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment-return zmdi-hc-fw"></i> <span>assignment-return</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment-returned zmdi-hc-fw"></i> <span>assignment-returned</span></a>
                    </div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-assignment zmdi-hc-fw"></i> <span>assignment</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-attachment-alt zmdi-hc-fw"></i> <span>attachment-alt</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-attachment zmdi-hc-fw"></i> <span>attachment</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-audio zmdi-hc-fw"></i>
                        <span>audio</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-bg-check zmdi-hc-fw"></i> <span>bg-check</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-balance-wallet zmdi-hc-fw"></i> <span>balance-wallet</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-balance zmdi-hc-fw"></i>
                        <span>balance</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-battery-alert zmdi-hc-fw"></i> <span>battery-alert</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-battery-flash zmdi-hc-fw"></i> <span>battery-flash</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-battery-unknown zmdi-hc-fw"></i> <span>battery-unknown</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-battery zmdi-hc-fw"></i>
                        <span>battery</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-bike zmdi-hc-fw"></i>
                        <span>bike</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-block-alt zmdi-hc-fw"></i> <span>block-alt</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-block zmdi-hc-fw"></i>
                        <span>block</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-boat zmdi-hc-fw"></i>
                        <span>boat</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-book-image zmdi-hc-fw"></i> <span>book-image</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-book zmdi-hc-fw"></i>
                        <span>book</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-bookmark-outline zmdi-hc-fw"></i> <span>bookmark-outline</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-bookmark zmdi-hc-fw"></i> <span>bookmark</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-brush zmdi-hc-fw"></i>
                        <span>brush</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-bug zmdi-hc-fw"></i>
                        <span>bug</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-bus zmdi-hc-fw"></i>
                        <span>bus</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-cake zmdi-hc-fw"></i>
                        <span>cake</span></a></div>
                    <div class="icon col-lg-4 col-md-6 col-sm-12"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-car-taxi zmdi-hc-fw"></i> <span>car-taxi</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-car-wash zmdi-hc-fw"></i>
                        <span>car-wash</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-car zmdi-hc-fw"></i>
                        <span>car</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-card-giftcard zmdi-hc-fw"></i>
                        <span>card-giftcard</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-card-membership zmdi-hc-fw"></i>
                        <span>card-membership</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-card-travel zmdi-hc-fw"></i>
                        <span>card-travel</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-card zmdi-hc-fw"></i>
                        <span>card</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-case-check zmdi-hc-fw"></i>
                        <span>case-check</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-case-download zmdi-hc-fw"></i>
                        <span>case-download</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-case-play zmdi-hc-fw"></i>
                        <span>case-play</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-case zmdi-hc-fw"></i>
                        <span>case</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-cast-connected zmdi-hc-fw"></i>
                        <span>cast-connected</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-cast zmdi-hc-fw"></i>
                        <span>cast</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-chart-donut zmdi-hc-fw"></i>
                        <span>chart-donut</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-chart zmdi-hc-fw"></i>
                        <span>chart</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-city-alt zmdi-hc-fw"></i>
                        <span>city-alt</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-city zmdi-hc-fw"></i>
                        <span>city</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-close-circle-o zmdi-hc-fw"></i>
                        <span>close-circle-o</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-close-circle zmdi-hc-fw"></i>
                        <span>close-circle</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-close zmdi-hc-fw"></i>
                        <span>close</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-cocktail zmdi-hc-fw"></i>
                        <span>cocktail</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-code-setting zmdi-hc-fw"></i>
                        <span>code-setting</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-code-smartphone zmdi-hc-fw"></i>
                        <span>code-smartphone</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-code zmdi-hc-fw"></i>
                        <span>code</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-coffee zmdi-hc-fw"></i>
                        <span>coffee</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-bookmark zmdi-hc-fw"></i> <span>collection-bookmark</span></a>
                    </div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-case-play zmdi-hc-fw"></i> <span>collection-case-play</span></a>
                    </div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-folder-image zmdi-hc-fw"></i>
                        <span>collection-folder-image</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-image-o zmdi-hc-fw"></i> <span>collection-image-o</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-image zmdi-hc-fw"></i>
                        <span>collection-image</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-1 zmdi-hc-fw"></i>
                        <span>collection-item-1</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-2 zmdi-hc-fw"></i>
                        <span>collection-item-2</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-3 zmdi-hc-fw"></i>
                        <span>collection-item-3</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-4 zmdi-hc-fw"></i>
                        <span>collection-item-4</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-5 zmdi-hc-fw"></i>
                        <span>collection-item-5</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-6 zmdi-hc-fw"></i>
                        <span>collection-item-6</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-7 zmdi-hc-fw"></i>
                        <span>collection-item-7</span></a></div>
                    <div class="icon col-sm-4 col-xs-6"><a href="javascript:void(0);"><i
                          class="zmdi zmdi-collection-item-8 zmdi-hc-fw"></i>
                        <span>collection-item-8</span></a></div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
